import { default as indexs6mqyc9cVbMeta } from "/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/pages/index.vue")
  }
]